import type { CursorPage } from './mouse.types'

/**
 * Mouse's paginated reads answer `{ data, next_cursor }` (the products and
 * orders lists) and its plain lists answer a bare array. Both become one
 * `CursorPage` here so the pages have a single "is there more" check. A bare
 * array is a complete list, so its cursor is null.
 */
/** A Mouse list envelope; `authority` and the like ride along and are dropped. */
type Envelope<T> = {
  data: T[]
  next_cursor?: string | null
  cursor?: string | null
} & Record<string, unknown>

export function toCursorPage<T>(raw: T[] | Envelope<T>): CursorPage<T> {
  if (Array.isArray(raw)) return { data: raw, cursor: null }
  return { data: raw.data, cursor: raw.next_cursor ?? raw.cursor ?? null }
}

/** Plain lists that Mouse might one day page: take the rows either way. */
export function toList<T>(raw: T[] | Envelope<T>): T[] {
  return Array.isArray(raw) ? raw : raw.data
}
